module.exports = __webpack_public_path__ + "static/media/LEC.46d103b4.png";